import { createAsyncThunk } from "@reduxjs/toolkit";
import { type SeriesPoint } from "../../../domain/entities/referral-backoffice";
import { type SummaryParams } from "../../../domain/repos/referrals-backoffice-repo";
import { type ReferralsBackofficeDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

/**
 * The admin chart's weekly buckets. A separate read from the main summary
 * because the endpoint buckets by week or by day and this screen needs both —
 * weeks for the trend, days for the row sparklines. Only the series is kept;
 * the KPIs come from the main read.
 */
export const getWeeklyTrend = createAsyncThunk<
  SeriesPoint[],
  Omit<SummaryParams, "series" | "seriesPeriods">,
  { dispatch: ReferralsBackofficeDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.GET_WEEKLY_TREND, async (params, { extra }) => {
  const summary = await extra.referralsBackofficeRepo.summary({
    ...params,
    series: "week",
  });
  return summary.series ?? [];
});
